import Button from "../../../../../common/components/atom/Button/Button";
import SelectInput from "../../../../../common/components/atom/SelectInput/SelectInput";
import TextInput from "../../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../../common/components/molecule/MessageCard/MessageCard";
import { UserRole } from "../../../../user/types/user.types";
import { HardwaresType } from "../../../types/hardware.types";
import {
  NewHardwareData,
  NewHardwareErrorState,
} from "../AddNewHardwareFromPresenter";
import styles from "./AddHardwareFormView.module.scss";

export interface NewHardwareFormProps {
  formData?: NewHardwareData;
  setFormData: (key: keyof NewHardwareData, value: string) => void;
  errorStatus?: NewHardwareErrorState;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
}

export default function AddHardwareFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations du nouveau hardware",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
}: NewHardwareFormProps) {
  const optionTypelist: { label: string; value: HardwaresType }[] = [
    { label: "Station", value: "STATION" },
    { label: "Borne", value: "CHARGEPOINT" },
  ];

  const deviceIdLabel =
    formData?.hardwareType === "STATION" ? "Device ID (Numéro)" : "Device ID";

  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={deviceIdLabel}
              value={formData?.deviceID}
              error={errorStatus?.isErrorDeviceID}
              onChange={(e) => {
                const value = e.target.value;

                setFormData("deviceID", value);
              }}
            />
          </div>

          {formData?.hardwareType === "STATION" && (
            <>
              <div className={[styles["form__item"]].join(" ")}>
                <TextInput
                  label={"Clé secrète"}
                  value={formData?.secretKey}
                  error={errorStatus?.isErrorSecretKey}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData("secretKey", value);
                  }}
                />
              </div>

              <div className={[styles["form__item"]].join(" ")}>
                <TextInput
                  label={"Clé secrète des avoirs"}
                  value={formData?.secretKeyCredit}
                  error={errorStatus?.isErrorSecretKeyCredit}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData("secretKeyCredit", value);
                  }}
                />
              </div>
            </>
          )}
          <div className={[styles["form__item"]].join(" ")}>
            <SelectInput
              label={"Hardware Type"}
              value={formData?.hardwareType}
              error={errorStatus?.isErrorHardwareType}
              handleChange={(value) => {
                setFormData("hardwareType", value);
              }}
              options={optionTypelist}
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
